import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalerieSelecteurService } from './galerie-selecteur';
import { RoleUtil } from './role.util';

/**
 * Bouton « Galerie Wanar » à côté d'un champ d'image : la photo choisie est rendue en fichier (image
 * d'affichage), le formulaire l'envoie comme un fichier choisi sur l'appareil. Caché pour le rôle Contenu
 * (Galerie fermée à ce rôle).
 */
@Component({
  selector: 'bay-bouton-galerie',
  template: `
    <button *ngIf="visible" type="button" [class]="classe" (click)="choisir()" [disabled]="desactive || attente" data-test="bouton-galerie">
      <span class="material-symbols-outlined align-middle me-1" style="font-size:16px;" aria-hidden="true">photo_library</span>
      {{ attente ? 'Récupération…' : libelle }}
    </button>
  `
})
export class BoutonGalerieComponent {
  @Input() libelle = 'Galerie Wanar';
  @Input() classe = 'btn btn-sm btn-outline-success rounded-3';
  @Input() desactive = false;
  @Output() fichier = new EventEmitter<File>();

  readonly visible = !RoleUtil.estContenu();
  attente = false;

  constructor(private selecteur: GalerieSelecteurService) {}

  async choisir(): Promise<void> {
    this.attente = true;
    try {
      const f = await this.selecteur.choisirFichier();
      if (f) { this.fichier.emit(f); }
    } catch { /* fenêtre fermée ou image illisible : rien n'est envoyé */ }
    this.attente = false;
  }
}
